import { CSSProperties, useState } from 'react';

import { Checkmark } from '@carbon/icons-react';
import { StyledSwitcher, StyledSwitcherWrapper } from './styled';

type Option<T extends string> = {
  label: string | React.ReactNode;
  value: T;
};

export type ContentSwitcherProps<T extends string> = {
  /**
   * Ровн две опции для выбора значения
   */
  options: [Option<T>, Option<T>];

  /**
   * Текущая выбранная опция (Управляемый режим)
   */
  value?: T;

  /**
   * Выбранная опция по умолчанию (Неуправляемые режим)
   */
  defaultValue?: T;

  /**
   * Функция изменения состояния
   */
  onChange?: (value: T) => void;

  /**
   * Стили для элемента Swticher
   */
  switcherStyles?: CSSProperties;
};

export function ContentSwitcher<T extends string>({
  options,
  value = undefined,
  onChange = undefined,
  defaultValue = undefined,
  switcherStyles = undefined,
}: ContentSwitcherProps<T>) {
  const [internalValue, setInternalValue] = useState<T>(defaultValue ?? options[0].value);

  const isControlled = value !== undefined;
  const activeValue = isControlled ? value : internalValue;

  const handleChange = (v: T) => {
    if (!isControlled) setInternalValue(v);
    onChange?.(v);
  };

  return (
    <StyledSwitcherWrapper>
      {options.map((option) => (
        <StyledSwitcher
          key={option.value}
          $active={activeValue === option.value}
          onClick={() => handleChange(option.value)}
          style={switcherStyles}
          type="button"
        >
          {option.label}
          {activeValue === option.value && <Checkmark fill="#16161640" />}
        </StyledSwitcher>
      ))}
    </StyledSwitcherWrapper>
  );
}
